"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.customEngineAgentTemplates = void 0;
const templateNames_1 = require("../templateNames");
exports.customEngineAgentTemplates = [
    {
        id: "basic-custom-engine-agent-ts",
        name: templateNames_1.TemplateNames.BasicCustomEngineAgent,
        language: "typescript",
        description: "",
    },
    {
        id: "basic-custom-engine-agent-js",
        name: templateNames_1.TemplateNames.BasicCustomEngineAgent,
        language: "javascript",
        description: "",
    },
    {
        id: "weather-agent-ts",
        name: templateNames_1.TemplateNames.WeatherAgent,
        language: "typescript",
        description: "",
    },
    {
        id: "weather-agent-js",
        name: templateNames_1.TemplateNames.WeatherAgent,
        language: "javascript",
        description: "",
    },
    {
        id: "custom-copilot-weather-agent-csharp",
        name: templateNames_1.TemplateNames.WeatherAgent,
        language: "csharp",
        description: "",
    },
];
//# sourceMappingURL=customEngineAgent.js.map